export const ORDER_AUTH_BROADCAST_CHANNEL = 'order-auth-broadcast-channel';
